// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"a1118c85","453":"67abf6b8"}[chunkId] + ".chunk.js";
};